<template>
  <div v-if="!!pageList" class="container">
    <!-- <router-link :to="{name: 'payment', params: {admin: 'payment'}}" v-if="pageLimit" class="limitInfo">
      {{`${locale.service_limit_page_3} ${locale.service_suggest_upgrade}`}}
    </router-link> -->
    <p v-if="pageLimit" class="limitInfo">{{`${locale.service_limit_page_3} ${locale.service_suggest_upgrade}`}}</p>
    <section id="editContent" class="columnContainer">
      <div class="innerColumn">
        <h1 class="contentTitle">{{locale.nav_page}}</h1>
        <div>
          <PageList
            :locale="locale"
            :pageLimit="pageLimit"
            :main="setPageList.main"
            :list="pageGroup"
            :init="setInit"
            @checked="onChecked" />
          <Pagination
            :option="pagingOption"
            @onPagingClick="onPagingClick" />
        </div>
      </div>
      <div class="innerSide"><div class="sideBox">
        <div class="innerItem filterInput">
          <p class="innerTitle toCapitalize f_medium">{{locale.search}}</p>
          <input type="text" class="input" :placeholder="locale.search_placeholder" v-model="categoryFilter.word" @keyup="initPaging">
        </div>
        <CategoryList
          :locale="locale"
          :state="categoryState"
          :option="categoryOption" />
      </div></div>
    </section>
    <div id="setContent">
      <SetPages
        :locale="locale"
        :checked="checkedList"
        :list="pageList"
        :pageLimit="pageLimit"
        :showTemplates="showTemplates"
        @checkTemplates="onCheckTemplates"
        @uncheckedAll="onUncheckedAll" />
    </div>
    <Templates
      v-if="showTemplates" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CategoryList from '@/components/Category/List'
import PageList from '@/components/Page/List'
import SetPages from '@/components/Page/SettingList'
import Pagination from '@/components/Pagination/Pagination'
import Templates from '@/components/Page/Templates.vue'

export default {
  name: 'Page',
  components: {
    CategoryList,
    PageList,
    SetPages,
    Pagination,
    Templates
  },
  props: [
    'locale',
    'paging'
  ],
  computed: {
    ...mapGetters({
      pageList: 'page/list',
      getCheckedCategory: 'category/getChecked',
      getCategoryList: 'category/list',
      getCategoryIds: 'category/ids',
      authInfo: 'authentication/getAuthInfo'
    }),
    // basic 사이트는 페이지 생성 최대 3개까지 가능
    pageLimit () {
      const isBasic = this.authInfo.sitePlan === 'basic'
      return isBasic && this.pageList.length >= 3
    },
    // 페이지 리스트 카테고리 필터
    categoryFilter: {
      get () {
        return this.$store.getters['category/getFilter']
      },
      set (val) {
        const data = {
          word: val.word.trim().toLowerCase(), // 검색어는 대소문자, 공백 무시
          list: val.list
        }
        this.$store.commit('category/setFilter', data)
      }
    },
    /**
     * 페이지 리스트 중 메인페이지 분리
     * 검색 필터 (분리된 페이지만)
     * 카테고리별 필터 (분리된 페이지만)
     * 메인페이지는 항상 최상단에 고정 노출
     */
    setPageList () {
      const mainId = this.$store.getters['setting/getMain'].page
      const main = this.pageList ? this.pageList.find(x => x.pageid === mainId) : []
      const categoryListIds = this.getCategoryIds
      let list = this.pageList ? this.pageList.filter(x => x.pageid !== mainId) : []
      const word = this.categoryFilter.word.toLowerCase()
      if (!!word && word.trim().length !== 0) {
        // 검색어
        list = list.filter(x => x.pageData.title.trim().toLowerCase().indexOf(word) !== -1)
      }
      if (!!this.getCheckedCategory && this.getCheckedCategory.length > 0) {
        // 카테고리 필터
        const checkedCategory = this.getCheckedCategory
        // 언카테고라이즈
        const unCategorizedList = checkedCategory.includes('uncategorized')
          ? list.filter(
            x => x.pageData.category === null || // 카테고리 데이터가 null이거나
            typeof (x.pageData.category) === 'undefined' || // 데이터가 없거나
            x.pageData.category.length === 0 || // 빈배열이거나
            categoryListIds.filter(xx => x.pageData.category.includes(xx)).length === 0) // 있지만 삭제되어서 못찾거나
          : []
        // 카테고리 필터시 언카테고라이즈 추가
        list = unCategorizedList.concat(
          list.filter(x => {
            if (x.pageData.category !== null && typeof (x.pageData.category) !== 'undefined' && x.pageData.category.length > 0) {
              const filterCategory = function (arr) {
                for (let i = 0; i < checkedCategory.length; i++) {
                  if (arr.indexOf(checkedCategory[i]) !== -1) {
                    return 'exist'
                  }
                }
              }
              if (filterCategory(x.pageData.category) === 'exist') { return x }
            }
          })
        )
      } else {
        list = []
      }
      return {
        main: main,
        list: list
      }
    },
    // 메인 분리 및 검색 or 카테고리 필터 된 리스트 최종 props 전달
    pageGroup () {
      const sort = this.sortBy
      const list = Sort(this.setPageList.list)
      function Sort (arr) {
        return arr.sort(function (a, b) {
          a[sort] = a[sort] ? a[sort] : a.createat
          b[sort] = b[sort] ? b[sort] : b.createat
          return a[sort] > b[sort] ? -1 : a[sort] < b[sort] ? 1 : 0
        })
      }
      const itemCount = this.pagingData.itemCount
      const start = (this.paging - 1) * itemCount
      return list.slice(start, start + itemCount)
    },
    /**
     * 리스트 페이징 옵션
     * limit: 페이저 길이 (전체 리스트/리스트당 아이템개수)
     * force: 활성화될 페이징(기본: 1, 라우터의 페이징 넘버 전달받아 assigin)
     */
    pagingOption () {
      return {
        limit: parseInt(this.setPageList.list.length / this.pagingData.itemCount) + 1,
        force: Number(this.paging)
      }
    }
  },
  created () {
    this.init()
    this.$store.commit('onLoading', true)
    this.$store.dispatch('page/setPageListData').then(() => {
      setTimeout(() => {
        this.$store.commit('onLoading', false)
      }, 1000)
    })
  },
  mounted () {
  },
  data () {
    return {
      showTemplates: false,
      setInit: false,
      sortBy: 'updateat',
      categoryOption: { // 필터용 카테고리 옵션
        editItem: false,
        checkbox: true,
        checkAll: true
      },
      categoryState: { // 필터용 카테고리 상태
        open: false,
        checked: true
      },
      checkedList: [],
      pagingData: {
        itemCount: 10 // 페이지당 노출할 리스트 아이템
      }
    }
  },
  methods: {
    init () {
      this.showTemplates = false
      this.$store.commit('category/setFilter', { word: '', ids: [] })
    },
    initPaging () {
      if (this.categoryFilter.word.trim().length > 0) {
        this.$router.replace({
          params: { paging: 1 }
        })
      }
    },
    onChecked (ids) {
      this.checkedList = ids
      this.setInit = false
    },
    onPagingClick (current) {
      this.$router.replace({ name: 'pageList', params: { paging: current } })
    },
    onUncheckedAll () {
      this.setInit = true
    },
    onCheckTemplates (toggle) {
      this.showTemplates = toggle
    }
  }
}
</script>
